import { attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { AttributeDefinition, AttributeInputType, AttributeTargetType } from "../Data/WBData";
import { AttributeFieldProps } from "./RenderAttributeInput";
import SelectField from "./SelectField";
import { SiteData } from "../Data/SiteData";


export const browserSafeFonts = [
"Arial",
"Arial Black",
"Arial Narrow",
"Courier New",
"Georgia",
"Impact",
"Lucida Sans Unicode",
"Palatino",
"Tahoma",
"Times New Roman",
"Trebuchet MS",
"Verdana",
"proxima-nova",

]
//google fonts
export const googleFonts = [
    'Oswald',
    'Source Sans Pro',
    'Hind',
    'Nunito Sans',
    'Roboto',
    'Open Sans',
    'Montserrat',
    'Playfair Display',
    'Lato',
    'Be Vietnam',
    'Neuton',
    'Noto Serif',
    'Della Respira',
    'Bitter',
    'DM Sans',
    'Tangerine',
    'Quicksand',
    'Alumni Sans',
    'Arvo',
    'Borel',
    'Caprasimo',
    'Comfortaa',
    'Cormorant Garamond',
    'Dancing Script',
    'Dosis',
    'Gloock',
    'Italiana',
    'Josefin Sans',
    'Josefin Slab',
    'Lobster Two',
    'Mooli',
    'Old Standard TT',
    'Pacifico',
    'Passion One',
    'Petit Formal Script',
    'Podkova',
    'Raleway',
    'Rubik',
    'Sacramento',
    'Satisfy',
    'Teko',
    'Ubuntu',
    'Unica One',
    'Work Sans',
    'Young Serif',
    'Marcellus',
    'Merriweather',
    'Cabin',
    'Baloo',
    'Exo',
    'Titillium Web',
    'Maven Pro',
    'Noticia Text',
    'Archivo',
    'Bebas Neue',
    'Cormorant',
    'Yantramanav',
    'Alegreya Sans',
    'Fjalla One',
    'Archivo Narrow',
    'Anton',
    'Catamaran',
    'Abril Fatface',
    'Rajdhani',
    'Monda',
    'Varela Round',
    'Caveat',
    'Acme',
    'Sarabun',
    'Candal',
    'Marmelad',
    'Kanit',
    'Cinzel',
    'EB Garamond',
    'Poiret One',
    'Scope One',
    'Barlow',
    'Chivo',
    'Arima Madurai',
    'Vollkorn',
    'Asap',
    'Overpass',
    'Archivo Black',
    'Gudea',
    'Spectral',
    'Karla',
    'Alata',
    'Nanum Gothic',
    'Lobster',
    'Quattrocento',
    'Vidaloka',
    'Parisienne',
    'Kreon',
    'Oxygen',
    'Fira Mono',
    'Mukta',
    'PT Serif',
    'Cutive',
    'Amaranth',

]




export function GetFontOptions(siteData:SiteData,includeAuto=true,includeAddOption = false){

    let allFonts = [...browserSafeFonts,...googleFonts];
    allFonts.sort((a,b)=>a.toLowerCase().localeCompare(b.toLowerCase()));

    const fontOptions = [];


    if(includeAuto)
        fontOptions.push({label:"Auto",value:""});

    if(includeAddOption){
        fontOptions.push({label:<span style={{color:"var( --input-selected-primary)"}}>+ Upload New Font</span>,value:"addfont"});
    }

    // Add custom fonts at the beginning
    let hasCustomFonts = false;
    for(let i = 0; i < siteData.siteStyling.customFonts.length; i++){
        let f = siteData.siteStyling.customFonts[i];
        let split = f.split("family=");

        if(split && split.length == 2 && split[1] != ""){
            if(!hasCustomFonts){
                hasCustomFonts = true;
                fontOptions.push({label:"⎯⎯⎯⎯⎯⎯⎯⎯ Custom Fonts ⎯⎯⎯⎯⎯⎯⎯⎯",value:"custom-divider",isDivider:true});
            }

            let val = split[1].replaceAll("+"," ").trim();
            const label = <span style={{fontFamily:val}}>{val}</span>
            fontOptions.push({label:label,value:val,rawLabel:val});
        }
    }

    // Add system and Google fonts after custom fonts
    if(hasCustomFonts) {
        fontOptions.push({label:"⎯⎯⎯⎯⎯ System & Google Fonts ⎯⎯⎯⎯",value:"system-divider",isDivider:true});
    }

    const imgURLRoot = `${process.env.PUBLIC_URL}/fontpreviews/`;

    for(let i = 0;i<allFonts.length;i++){

        let labelText = allFonts[i];

        if(labelText.includes("-")){
            let split = labelText.split("-");
            labelText = "";

            for(let j = 0;j<split.length;j++){
                labelText += split[j].charAt(0).toUpperCase() + split[j].slice(1);
                if(j<split.length-1)
                labelText += " ";

            }
        }

        let fnt = allFonts[i];


        const imgFile = fnt.replaceAll(" ","-").toLowerCase()+".png";


        const imgURL = `${imgURLRoot}${imgFile}`
        const label =  <><img loading="lazy" alt={labelText} src={imgURL}  height={24}/><span style={{display:"none"}}>{labelText}</span></>
        fontOptions.push({label:label,value:allFonts[i],rawLabel:allFonts[i]});

    }



    return fontOptions;
}

export default function FontField({label,definition,layoutObject,updateFunc,screenSize,siteData,saveFunc}:AttributeFieldProps){

    const fontOptions = GetFontOptions(siteData);


    const fontAtt = new AttributeDefinition(attributeTypes.fontFamily,"Font","",AttributeInputType.SelectField, fontOptions,null,AttributeTargetType.Style);

    return <SelectField extraClass="font-selection" allowFilter={true} label={label} definition={fontAtt} layoutObject={layoutObject} updateFunc={
        (a:any,b:any,c:any)=>{
            updateFunc(a,b,c);
            siteData.designer&&siteData.designer.updateMasterLayout();

        }
        } screenSize={screenSize} siteData={siteData} saveFunc={saveFunc} />




}